<div [ngClass]="{ hidden: !isPrepaymentEnabled }">
  <h4 class="fd-subtitle">
    {{ isAnticipationExternal ? 'Taxa de antecipação automática com agenda externa' : 'Taxa de antecipação automática' }}
  </h4>
  <app-prepayment-table (backAction)="back()"></app-prepayment-table>
</div>

<h4 class="fd-subtitle">{{ isPrepaymentEnabled ? 'Taxas MDR Antecipação' : 'Taxas MDR' }}</h4>

<form *ngIf="formGroup" [formGroup]="formGroup">
  <div class="fd-table__scroll">
    <table mat-table [dataSource]="dataSourceByFlag" class="fd-table">
      <ng-container matColumnDef="flag" *ngIf="!viewFlagImg">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Bandeira</th>
        <td mat-cell *matCellDef="let row" class="fd-table__cell">
          {{ row.flag | uppercase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="flag" *ngIf="viewFlagImg">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Bandeira</th>
        <td mat-cell *matCellDef="let row" class="fd-table__cell">
          <img [class]="row.flag" [src]="getFlagImageURL(row.flag)" [alt]="row.flag" />
        </td>
      </ng-container>

      <ng-container matColumnDef="credito">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Crédito</th>
        <td mat-cell *matCellDef="let row" class="fd-table__cell">
          <ng-container *ngIf="row?.credito?.index !== undefined && row?.credito?.model; else creditReadonly">
            <div formArrayName="feeForms">
              <div [formGroupName]="row.credito.index">
                <fd-fee-editor
                  [canEdit]="canEdit(row.credito.model.modality)"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, row.credito.index)"
                  [parentForm]="feeFormsControls[row.credito.index]"
                  [field]="fieldsArray[row.credito.index].suggestedMdrFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #creditReadonly>
            <ng-container [ngSwitch]="row.credito !== null && row.credito !== undefined">
              <span *ngSwitchCase="true">{{ row.credito | number: '1.2-2' }}%</span>
              <span *ngSwitchDefault>–</span>
            </ng-container>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="debito">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Débito</th>
        <td mat-cell *matCellDef="let row" class="fd-table__cell">
          <ng-container *ngIf="row?.debito?.index !== undefined && row?.debito?.model; else debitReadonly">
            <div formArrayName="feeForms">
              <div [formGroupName]="row.debito.index">
                <fd-fee-editor
                  [canEdit]="canEdit(row.debito.model.modality)"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, row.debito.index)"
                  [parentForm]="feeFormsControls[row.debito.index]"
                  [field]="fieldsArray[row.debito.index].suggestedMdrFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #debitReadonly>
            <ng-container [ngSwitch]="row.debito !== null && row.debito !== undefined">
              <span *ngSwitchCase="true">{{ row.debito | number: '1.2-2' }}%</span>
              <span *ngSwitchDefault>–</span>
            </ng-container>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="parceladoAte6">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Parcelamento em até 6x</th>
        <td mat-cell *matCellDef="let row" class="fd-table__cell">
          <ng-container *ngIf="row?.parceladoAte6?.index !== undefined && row?.parceladoAte6?.model; else ate6Readonly">
            <div formArrayName="feeForms">
              <div [formGroupName]="row.parceladoAte6.index">
                <fd-fee-editor
                  [canEdit]="canEdit(row.parceladoAte6.model.modality) || row.flag === 'Todas'"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, row.parceladoAte6.index)"
                  [parentForm]="feeFormsControls[row.parceladoAte6.index]"
                  [field]="fieldsArray[row.parceladoAte6.index].suggestedMdrFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #ate6Readonly>
            <ng-container [ngSwitch]="row.parceladoAte6 !== null && row.parceladoAte6 !== undefined">
              <span *ngSwitchCase="true">{{ row.parceladoAte6 | number: '1.2-2' }}%</span>
              <span *ngSwitchDefault>–</span>
            </ng-container>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="parceladoMais6">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Parcelamento mais de 6x</th>
        <td mat-cell *matCellDef="let row" class="fd-table__cell">
          <ng-container *ngIf="row?.parceladoMais6?.index !== undefined && row?.parceladoMais6?.model; else mais6Readonly">
            <div formArrayName="feeForms">
              <div [formGroupName]="row.parceladoMais6.index">
                <fd-fee-editor
                  [canEdit]="canEdit(row.parceladoMais6.model.modality) || row.flag === 'Todas'"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, row.parceladoMais6.index)"
                  [parentForm]="feeFormsControls[row.parceladoMais6.index]"
                  [field]="fieldsArray[row.parceladoMais6.index].suggestedMdrFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #mais6Readonly>
            <ng-container [ngSwitch]="row.parceladoMais6 !== null && row.parceladoMais6 !== undefined">
              <span *ngSwitchCase="true">{{ row.parceladoMais6 | number: '1.2-2' }}%</span>
              <span *ngSwitchDefault>–</span>
            </ng-container>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="crediario">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Crediário</th>
        <td mat-cell *matCellDef="let row" class="fd-table__cell">
          <ng-container *ngIf="row?.crediario?.index !== undefined && row?.crediario?.model; else crediarioReadonly">
            <div formArrayName="feeForms">
              <div [formGroupName]="row.crediario.index">
                <fd-fee-editor
                  [canEdit]="canEdit(row.crediario.model.modality)"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, row.crediario.index)"
                  [parentForm]="feeFormsControls[row.crediario.index]"
                  [field]="fieldsArray[row.crediario.index].suggestedMdrFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #crediarioReadonly>
            <ng-container [ngSwitch]="row.crediario !== null && row.crediario !== undefined">
              <span *ngSwitchCase="true">{{ row.crediario | number: '1.2-2' }}%</span>
              <span *ngSwitchDefault>–</span>
            </ng-container>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="voucher">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header fd-table__header--with-tip">
          <span>Voucher</span>

          <fa-icon
            *ngIf="hasVoucherMsg"
            mat-button
            icon="info-circle"
            size="1x"
            class="tooltip-voucher tooltip-icon"
            [matTooltip]="getTextOfModalVoucher()"
            matTooltipClass="pre-line-tooltip"
            matTooltipPosition="right"
            (click)="$event.stopPropagation()"
            aria-label="Informação sobre Voucher"
          ></fa-icon>
        </th>

        <td mat-cell *matCellDef="let row" class="fd-table__cell">
          <ng-container *ngIf="row?.voucher?.index !== undefined && row?.voucher?.model; else voucherReadonly">
            <div formArrayName="feeForms">
              <div [formGroupName]="row.voucher.index">
                <fd-fee-editor
                  [canEdit]="canEdit(row.voucher.model.modality)"
                  (openDialogFn)="openMdrFlexFeeEditorModal($event, row.voucher.index)"
                  [parentForm]="feeFormsControls[row.voucher.index]"
                  [field]="fieldsArray[row.voucher.index].suggestedMdrFee"
                ></fd-fee-editor>
              </div>
            </div>
          </ng-container>
          <ng-template #voucherReadonly>
            <ng-container [ngSwitch]="row.voucher !== null && row.voucher !== undefined">
              <span *ngSwitchCase="true">{{ row.voucher | number: '1.2-2' }}%</span>
              <span *ngSwitchDefault>–</span>
            </ng-container>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsByFlag" class="fd-table__header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsByFlag" class="fd-table__row"></tr>
    </table>
  </div>
</form>

<div *ngIf="isPfacAccreditationType()" class="receiving-deadline-question">
  <h4 class="fd-subtitle">Qual o prazo de liquidação?</h4>
  <fd-radio-button [parentForm]="formGroup" [field]="fields.receivingDeadline"></fd-radio-button>
</div>

<div *ngIf="isCEF" class="cef-disclaimer">
  As condições comerciais apresentadas nesta simulação referem-se ao item 6 da Solicitação de Credenciamento à CAIXA Pagamentos/FISERV,
  estabelecidas de acordo com o faturamento informado para o novo domicílio e o ramo de atividade do cliente, as quais estão sujeitas a
  aprovação da credenciadora.
</div>
<fd-button *ngIf="!isCEF" fdSecondary [content]="'cancelar'" (trigger)="back()"> </fd-button>
<fd-button *ngIf="isCEF" [content]="'finalizar'" (trigger)="saveSimulation()"> </fd-button>

<fd-button *ngIf="!isCEF" [content]="'avançar'" (trigger)="next()"> </fd-button>
